import React from 'react';

import Pocket from '../../../components/DataTable/PocketDataTable';

export default function MainMRG() {
    return (
        <Pocket
            requiredFields={['name']}
            type="main_mrg"
            project="games.mail.ru"
            columnsArray={[
                { type: 'number' },
                {
                    type: 'checkbox',
                    titleIcon: 'lock',
                    accessor: 'pos_locked',
                    attributes: {
                        'data-type': 'active-multi',
                    },
                },
                { type: 'type' },
                {
                    type: 'title',
                    accessor: 'entity.title',
                },
                { type: 'edit' },
                {
                    type: 'delete',
                    disabledAccessor: 'pos_locked',
                },
            ]}
            formFields={[
                {
                    type: 'storySearch',
                    name: 'storySearch',
                },
                {
                    type: 'input',
                    name: 'name',
                    label: 'Заголовок',
                    maxLength: 100,
                    // isMultilang: true,
                },
                {
                    type: 'textarea',
                    name: 'description',
                    label: 'Лид',
                    maxLength: 200,
                    textareaRows: 4,
                },
            ]}
        />
    );
}
